export interface Tag {
  displayValue: string;
  filterId?: string;
  styleClass?: string;
  translate?: boolean;
}
